import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
// Utility to get the recording moderation state slice
const getState = (state) => state['features/recording-moderation'];
// Function to check if recording moderation is enabled globally
export const isEnableBanAllRecording = (state) => getState(state)?.enabled;
// Function to check if the local participant is allowed to record
export const isLocalParticipantCanRecording = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canRecording } = getState(state);
    if (canRecording !== undefined) {
        return canRecording;
    }
    return !isEnableBanAllRecording(state);
};
// Function to check if a participant is approved for recording
export const isParticipantApprovedRecording = (participantId, state) => {
    return getState(state)?.whitelist[participantId];
};
// Function to check if a participant is rejected for recording
export const isParticipantRejectedRecording = (participantId, state) => {
    return getState(state)?.blacklist[participantId];
};
// Function to check if a participant is banned from recording
export function isBannedRecording(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanRecording(state);
    }
    // Moderators cannot be banned from recording
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAllRecording(state)) {
        return !isParticipantApprovedRecording(participant.id, state);
    }
    return Boolean(isParticipantRejectedRecording(participant.id, state));
}
